import { useState, useEffect } from 'react';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';

export function MicIcon() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_4613_23073)">
                <path d="M28.5 15.832V18.9987C28.5 21.9382 27.3938 24.7573 25.4246 26.8358C23.4555 28.9143 20.7848 30.082 18 30.082M18 30.082C15.2152 30.082 12.5445 28.9143 10.5754 26.8358C8.60625 24.7573 7.5 21.9382 7.5 18.9987V15.832M18 30.082V36.4154M12 36.4154H24M18 1.58203C16.8065 1.58203 15.6619 2.08248 14.818 2.97327C13.9741 3.86407 13.5 5.07225 13.5 6.33203V18.9987C13.5 20.2585 13.9741 21.4667 14.818 22.3575C15.6619 23.2483 16.8065 23.7487 18 23.7487C19.1935 23.7487 20.3381 23.2483 21.182 22.3575C22.0259 21.4667 22.5 20.2585 22.5 18.9987V6.33203C22.5 5.07225 22.0259 3.86407 21.182 2.97327C20.3381 2.08248 19.1935 1.58203 18 1.58203Z" stroke="#1E1E1E" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4613_23073">
                    <rect width="36" height="38" fill="white" />
                </clipPath>
            </defs>
        </svg>

    )
}

export function StopMicIcon() {
    return (
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15 9H9V15H15V9Z" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}


const SpeechToText = ({setTranscriptData}) => {
    const [transcript, setTranscript] = useState('');
    const [isListening, setIsListening] = useState(false);
    const [recognition, setRecognition] = useState(null);

    useEffect(() => {
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    
        if (SpeechRecognition) {
          const recognitionInstance = new SpeechRecognition();
          recognitionInstance.interimResults = true;
    
          recognitionInstance.onresult = (event) => {
            let interimTranscript = '';
            let finalTranscript = '';
    
            for (let i = 0; i < event.results.length; i++) {
              const result = event.results[i];
              if (result.isFinal) {
                finalTranscript += result[0].transcript + ' ';
              } else {
                interimTranscript += result[0].transcript + ' ';
              }
            }
            console.log('inte', interimTranscript)
            setTranscript(finalTranscript.trim());
            setTranscriptData(finalTranscript.trim()); // Update parent with new transcript
          };
    
          recognitionInstance.onend = () => {
            setIsListening(false);
          };
    
          setRecognition(recognitionInstance);
        } else {
          alert('Speech recognition not supported in this browser.');
        }
      }, [setTranscriptData]);

    const startListening = () => {
        if (recognition) {
            setTranscript(''); // Clear previous transcript
            recognition.start();
            setIsListening(true);
        }
    };

    const stopListening = () => {
        if (recognition) {
            setTranscriptData(transcript);
            recognition.stop();
            setIsListening(false);
        }
    };


    return (
        <div>
                {!isListening ? <IconButton onClick={() => startListening()}><MicIcon /></IconButton> : <IconButton onClick={() => stopListening()}><StopMicIcon /></IconButton> }
        </div>
    );
};

SpeechToText.propTypes = {
    setTranscriptData: PropTypes.any,
}

export default SpeechToText;
